
import wx from 'weixin-js-sdk'

export const wxPreviewImg = (url, urls) => {
    if (localStorage.AUTH_TYPE !== 'WECHAT') {
        alert('请在企业微信中打开')
        return
    }
    wx.previewImage({
        // current: event.target.src,
        current: url,
        urls: urls,
        fail: function (res) {
            console.log(33, res)
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/wxPreviewImg.js